import React, {useEffect, useState} from 'react';
import {buildAdminRequestParams, createPlayPresentationUrl, createShortRoomUrl} from '../../../../../utils/presentation';
import {useCreateAutoRoomSlug} from '../../../../../service/hooks/useRoomSlug';
import {IPresentationMeta} from '../../../../../incase-domain/presentation';
import PresentationLink from './PresentationLink';

interface IPresenterLinkProps {
    presentation: IPresentationMeta;
    roomId?: string;
    presenterLinkCode?: string;
}

function PresenterLink({presentation, roomId, presenterLinkCode}: IPresenterLinkProps): JSX.Element {
    const {mutateAsync: createAutoRoomSlug} = useCreateAutoRoomSlug();
    const fallbackLink = createPlayPresentationUrl({
        presentation,
        isCustom: false,
        roomId,
        presenterCode: presenterLinkCode,
    });
    const [presenterLink, setPresenterLink] = useState(fallbackLink);

    useEffect(() => {
        if (!roomId) {
            setPresenterLink(fallbackLink);
            return () => {
                // noop
            };
        }

        let cancelled = false;
        createAutoRoomSlug({roomId, presenterCode: presenterLinkCode, params: buildAdminRequestParams(presentation)})
            .then((slugDoc) => {
                if (!cancelled) setPresenterLink(createShortRoomUrl(slugDoc.slug));
            })
            .catch(() => {
                if (!cancelled) setPresenterLink(fallbackLink);
            });

        return () => {
            cancelled = true;
        };
    }, [roomId, presenterLinkCode, createAutoRoomSlug, presentation, fallbackLink]);

    return <PresentationLink link={presenterLink} dataCy="copy_presenter_link" />;
}

export default PresenterLink;
